import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page';
import { PageNotificationsProvider } from 'app/common/notifications/features/page-notifications/page-notifications.provider';
import { PageNotificationsRender } from 'app/common/notifications/features/page-notifications/page-notifications.render';
import { PageContent } from 'app/ui';

import { AddTariffProfile } from '../features/tariff-profile/add-tariff-profile/add-tariff-profile';

export const AddTariffProfilePage = observer(() => {
  return (
    <PageNotificationsProvider>
      <AppPage perm="PERM_TARIFF_PROFILE_CREATE">
        <PageContent>
          <PageNotificationsRender />
        </PageContent>

        <PageContent>
          <AddTariffProfile />
        </PageContent>
      </AppPage>
    </PageNotificationsProvider>
  );
});
